import Gikam from "./gikam-core";
import jQuery from 'jquery';


//销毁dropDownMenu组件
const dropDownDestroyHandle = function(){
    Gikam.dropDownMenuPicker && Gikam.dropDownMenuPicker.close();
}

document.addEventListener('click',dropDownDestroyHandle);
document.addEventListener('touchmove',dropDownDestroyHandle);

//销毁grid下generalGroup组件
const generalGroupDestroyHandle = function(){
    Gikam.generalGroupPanel && Gikam.generalGroupPanel.destroy();
}

document.addEventListener('click',generalGroupDestroyHandle);
document.addEventListener('touchmove',generalGroupDestroyHandle);

//销毁richText组件
const richTextDestroyHandle = function(){
    Gikam.textareaPicker && Gikam.textareaPicker.close();
}

document.addEventListener('mousewheel',richTextDestroyHandle);

document.addEventListener('mousedown',richTextDestroyHandle);

//销毁下拉框组建
const selectDestroyHandle = function(){
    let $selectPicker = jQuery('body>.select-picker');
    if ($selectPicker.length !== 0) {
        $selectPicker.data('relate').cleanSelectPicker();
    }
}

document.addEventListener('mousewheel',selectDestroyHandle);

document.addEventListener('mousedown',selectDestroyHandle);


// //销毁日期选择组件
const dateDestroyHandle = function(){
    let $datePicker = jQuery('body>.date-picker');
    if ($datePicker.length === 0) {
        return;
    }
    Gikam.getInstance($datePicker).destroy();
}
document.addEventListener('click',dateDestroyHandle);

document.addEventListener('mousewheel',dateDestroyHandle);

// //销毁年选择组件
const yearDestroyHandle = function(){
    if (!Gikam.yearPicker) {
        return;
    }
    Gikam.yearPicker.destroy();
}
document.addEventListener('click',yearDestroyHandle);

document.addEventListener('mousewheel',yearDestroyHandle);


//销毁时间选择组件
const timeDestroyHandle = function(){
    if (Gikam.timePicker) {
        Gikam.timePicker.destroy();
    }
}
document.addEventListener('click',timeDestroyHandle);
document.addEventListener('mousewheel',timeDestroyHandle);


//销毁grid通用查询面板
document.addEventListener('click', (e) => {
    let $panel = jQuery('body>.grid-generic-query-panel');
    if ($panel.length === 0) {
        return;
    }
    if ($panel.find(e.target).length > 0 || $panel[0] === e.target) {
        return;
    }
    Gikam.getInstance($panel).destroy();
});


jQuery.ajaxSetup({

    error: function (response) {
        if (!response.responseText) {
            return;
        }
        try {
            let r = JSON.parse(response.responseText);
            let catchError = [400, 500];

            catchError.indexOf(r.status) > -1
                && !Gikam.ignoreErrorUrl.some(function (item) {
                    return r.path.indexOf(item) > -1;
                })
                && Gikam.create('ErrorAlert', {
                    message: Gikam.propI18N(JSON.parse(response.responseText).message)
                });
        } catch (e) {
            //ignore
        }

    },

    success: function (response) {
        if ((typeof response === 'string' && response.indexOf('<!DOCTYPE') === 0) ||
            (typeof response === 'object' && response.message === 'core.security.login.unauthorized')
        ) {
            location.href = '/';
        }
    }
});



